import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Breadcrumb from "../../common/header/Breadcrumb";
import Header from "../../common/header/Header";
import SignatureNeededTemplate from "../../components/NotificationSettings/SignatureNeededTemplate";

const SignatureNeeded = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <Box sx={{ flexGrow: 1 }} className="page-background">
      <Header />
      <Breadcrumb />
      <SignatureNeededTemplate/>
    </Box>
  </>
  )
}

export default SignatureNeeded